(() => {
  const desktopMenuSelector = '[data-miw-mega-menu]';
  const mobileMenuSelector = '[data-miw-mobile-menu]';
  const desktopDetailsSelector = '.miw-mega-nav__details';
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const hoverOpenDelay = 140;
  const hoverCloseDelay = 220;

  const setExpanded = (details) => {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  };

  const closeDetails = (details) => {
    if (!details || !details.open) return;
    details.open = false;
    setExpanded(details);
  };

  const closeDesktopMenus = (menu, exceptDetails = null) => {
    menu.querySelectorAll(`${desktopDetailsSelector}[open]`).forEach((details) => {
      if (details !== exceptDetails) closeDetails(details);
    });
  };

  const initDesktopMenu = (menu) => {
    if (menu.dataset.miwMegaMenuBound === 'true') return;
    menu.dataset.miwMegaMenuBound = 'true';

    const openTimers = new WeakMap();
    const closeTimers = new WeakMap();

    const clearTimer = (timers, details) => {
      const timer = timers.get(details);
      if (!timer) return;
      window.clearTimeout(timer);
      timers.delete(details);
    };

    const scheduleOpen = (details) => {
      clearTimer(closeTimers, details);
      clearTimer(openTimers, details);
      openTimers.set(details, window.setTimeout(() => {
        details.open = true;
        setExpanded(details);
        closeDesktopMenus(menu, details);
      }, hoverOpenDelay));
    };

    const scheduleClose = (details) => {
      clearTimer(openTimers, details);
      clearTimer(closeTimers, details);
      closeTimers.set(details, window.setTimeout(() => closeDetails(details), hoverCloseDelay));
    };

    menu.querySelectorAll(desktopDetailsSelector).forEach((details) => {
      setExpanded(details);

      details.addEventListener('pointerenter', () => {
        if (!canHover.matches) return;
        scheduleOpen(details);
      });

      details.addEventListener('pointerleave', () => {
        if (!canHover.matches) return;
        scheduleClose(details);
      });
    });

    menu.addEventListener('toggle', (event) => {
      const activeDetails = event.target;
      if (!activeDetails.matches(desktopDetailsSelector)) return;

      setExpanded(activeDetails);
      if (activeDetails.open) closeDesktopMenus(menu, activeDetails);
    }, true);

    menu.addEventListener('keydown', (event) => {
      const openDetails = event.target.closest(`${desktopDetailsSelector}[open]`);
      if (event.key !== 'Escape' || !openDetails) return;

      event.preventDefault();
      closeDetails(openDetails);
      openDetails.querySelector('summary')?.focus();
    });

    document.addEventListener('click', (event) => {
      if (menu.contains(event.target)) return;
      closeDesktopMenus(menu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDesktopMenus(menu);
    });
  };

  const initMobileMenu = (menu) => {
    if (menu.dataset.miwMobileMenuBound === 'true') return;
    menu.dataset.miwMobileMenuBound = 'true';

    menu.querySelectorAll('details').forEach(setExpanded);

    menu.addEventListener('toggle', (event) => {
      const activeDetails = event.target;
      if (!activeDetails.matches('details')) return;

      setExpanded(activeDetails);
      if (!activeDetails.open) return;

      menu.querySelectorAll('details[open]').forEach((details) => {
        if (details !== activeDetails) closeDetails(details);
      });
    }, true);
  };

  const init = () => {
    document.querySelectorAll(desktopMenuSelector).forEach(initDesktopMenu);
    document.querySelectorAll(mobileMenuSelector).forEach(initMobileMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
